import { cls } from "@op/utils";
import { useMemo } from "react";
import type { LayoutRowProps } from "@op/puck-types";

const LayoutRow = ({
  variant,
  children,
  leftChildren,
  rightChildren,
  className,
}: LayoutRowProps) => {
  const variantClass = useMemo(() => {
    switch (variant) {
      case "full-width":
        return "one-col";
      case "narrow":
        return "three-col";
      case "wide":
        return "two-col";
      case "two-column":
        return "three-col";
    }
  }, [variant]);

  return (
    <div
      className={cls(
        "layout-row",
        variantClass,
        rightChildren ? "with-right-children" : undefined,
        className
      )}
    >
      {leftChildren && <div className={"left-children"}>{leftChildren}</div>}
      <div className={"children"}>{children}</div>
      {rightChildren && variant === "two-column" ? (
        <div className={"right-children"}>{rightChildren}</div>
      ) : null}
    </div>
  );
};

export default LayoutRow;
